import { render, staticRenderFns } from "./HlaVirtualCrossmatchResult.vue?vue&type=template&id=7779640d&"
import script from "./HlaVirtualCrossmatchResult.vue?vue&type=script&lang=ts&"
export * from "./HlaVirtualCrossmatchResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/hla/_locales/HlaVirtualCrossmatchResult.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fhla%2FHlaVirtualCrossmatchResult.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports